import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { getHistory } from '../services/chatService';
import MessageList from './messageList';
import EmptyMessage from './emptyMessage';
import LoadingScreen from './common/loadingScreen';
import { filterDuplicate } from '../utils/filter';
import Fab from './common/fab';

class Message extends Component {
  constructor(props) {
    super(props);
    this.messageList = React.createRef();
    this.fabButton = React.createRef();
  }

  state = {
    chats: [],
    currentPage: 0,
    currentCount: 0,
    hasMore: true,
    initialLoad: true,
    isLoading: false,
  };

  componentDidMount() {
    this.messageList.current.addEventListener('scroll', this.onScroll);
    this.getChatList();
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { initialLoad, chats } = this.state;
    const { newMessage, bgColor } = this.props;
    if (initialLoad) {
      return true;
    }
    if (nextState.isLoading) {
      return true;
    }
    if (nextState.chats.length !== chats.length) {
      return true;
    }
    if (newMessage !== nextProps.newMessage) {
      return true;
    }
    if (bgColor !== nextProps.bgColor) {
      return true;
    }
    return false;
  }

  componentDidUpdate() {
    const { currentPage, isLoading } = this.state;
    const { newMessage } = this.props;
    if (newMessage.length > 0) {
      this.updateChatList();
    }
    if (currentPage === 1 && !isLoading) {
      this.scrollToBottom();
    }
  }

  componentWillUnmount() {
    if (this.messageList) {
      this.messageList.current.removeEventListener('scroll', this.onScroll);
    }
  }

  onScroll = ({ target }) => {
    const { hasMore, isLoading } = this.state;
    if (!hasMore) return;
    const topPos = target.scrollTop;
    const node = this.messageList.current;
    if ((node.scrollHeight - node.scrollTop - node.clientHeight) >= 300) {
      this.fabButton.current.style.display = 'block';
    } else {
      this.fabButton.current.style.display = 'none';
    }
    if (topPos === 0) {
      if (!isLoading) {
        setTimeout(() => {
          this.getChatList();
        }, 500);
      }
    }
  };

  getChatList = async () => {
    const { currentPage, chats: chatState } = this.state;
    if (currentPage !== 0) this.setState({ isLoading: true });
    try {
      const {
        data: { results, next },
      } = await getHistory(currentPage);

      const cloneChat = [...results, ...chatState];
      const chatListClean = filterDuplicate(cloneChat, 'id');
      const chats = chatListClean.sort((o1, o2) => {
        if (o1.timestamp < o2.timestamp) return -1;
        if (o1.timestamp > o2.timestamp) return 1;
        return 0;
      });

      this.setState(prevState => ({
        chats,
        currentPage: prevState.currentPage + 1,
        hasMore: next !== null,
        currentCount: prevState.currentCount + results.length,
        isLoading: false,
        initialLoad: false,
      }));
    } catch (ex) {
      toast.error('The server is currently busy. Please try your operation again', {
        hideProgressBar: true,
        autoClose: 8000,
      });
      this.setState({
        isLoading: false,
        initialLoad: false,
      });
    }
  };

  updateChatList = () => {
    const { resetMessage } = this.props;
    this.setState((prevState, props) => ({ chats: [...prevState.chats, ...props.newMessage] }), () => {
      resetMessage();
      this.scrollToBottom();
    });
  }

  scrollToBottom = () => {
    const node = this.messageList.current;
    if (node) {
      node.scrollTop = node.scrollHeight;
    }
  }

  render() {
    const lines = [1, 2, 3];
    const { initialLoad, chats, isLoading } = this.state;
    const { bgColor } = this.props;
    return (
      <div className="chat" style={{ backgroundColor: bgColor }}>
        <Fab onScroll={this.scrollToBottom} ref={this.fabButton} />
        <div className="chatbox" ref={this.messageList}>
          {initialLoad && <LoadingScreen lines={lines} />}
          {chats.length > 0 && !initialLoad
            ? <MessageList chats={chats} isLoading={isLoading} />
            : <EmptyMessage />}
        </div>
      </div>
    );
  }
}

Message.defaultProps = {
  history: {},
  newMessage: [],
};
Message.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  newMessage: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    message: PropTypes.string,
    sender: PropTypes.string,
    timestamp: PropTypes.string,
    to: PropTypes.string,
  })),
  resetMessage: PropTypes.func.isRequired,
  bgColor: PropTypes.string.isRequired,
};
export default Message;
